"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = formatDate;
exports.setUTCDate = exports.localeHash = void 0;

var DateFns = _interopRequireWildcard(require("date-fns"));

var Locales = _interopRequireWildcard(require("date-fns/locale"));

/**
 * A hash map from our locales (as provided by the API) to the locales supported by date-fns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var localeHash = {
  // cs: Locales.cs, // Czech
  // da: Locales.da, // Danish
  de: Locales.de,
  // German
  en: Locales.enGB,
  // British English
  en_ca: Locales.enCA,
  // Canadian English
  en_us: Locales.enUS,
  // American English
  es: Locales.es,
  // Spanish
  es_mx: Locales.es,
  // Spanish
  // fi: Locales.fi, // Finnish
  fr: Locales.fr,
  // French
  fr_ca: Locales.fr,
  // French
  // id: Locales.id, // Indonesian
  it: Locales.it,
  // Italian
  jp: Locales.ja,
  // Japanese
  // ko_kr: Locales.ko, // Korean
  hu: Locales.enGB,
  // Hungarian not supported yet
  my: Locales.enGB,
  // Malaysian not supported yet
  nl: Locales.nl,
  // Dutch
  no: Locales.nb,
  // Norwegian
  // pl: Locales.pl, // Polish
  pt: Locales.pt,
  // Portuguese
  pt_br: Locales.ptBR,
  // Brazilian Portuguese
  ru: Locales.ru,
  // Russian
  sv: Locales.sv,
  // Swedish
  // th: Locales.th, // Thai
  // tl: Locales.fil, // Filipino
  // tr: Locales.tr, // Turkish
  zh_cn: Locales.zhCN,
  // Chinese Simplified
  zh_hk: Locales.zhCN // Chinese Simplified

};
exports.localeHash = localeHash;

function formatDate(format) {
  return function withLocale(locale) {
    return function withDate(date) {
      return DateFns.format(date, format, {
        locale: localeHash[locale]
      });
    };
  };
}

var setUTCDate = function setUTCDate(day) {
  return function (date) {
    var cloned = new Date(date);
    cloned.setUTCDate(day);
    return cloned;
  };
};

exports.setUTCDate = setUTCDate;
//# sourceMappingURL=Dates.js.map